import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import de from './de.json';
import pt from './pt.json';
import it from './it.json';

const translations = { en, es, fr, de, pt, it };

export default translations;

/**
 * Get a nested value from an object using dot notation.
 * e.g. get(obj, 'nav.explore') => obj.nav.explore
 */
function get(obj, path) {
  return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

/**
 * Returns a translator function for the given language code.
 * Falls back to English if key is missing.
 */
export function getTranslator(langCode) {
  const lang = translations[langCode] || translations.en;
  const fallback = translations.en;

  return function t(key, replacements) {
    let text = get(lang, key) ?? get(fallback, key) ?? key;
    if (replacements) {
      Object.entries(replacements).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), v);
      });
    }
    return text;
  };
}
